<template>
  <aside class="feed-desktop-aside">
    <div v-if="pendingResponses" class="feed-widget-card feed-widget-card--highlight">
      <div class="feed-widget-card__title">Pending responses</div>
      <p class="feed-widget-card__body">
        You have {{ pendingResponses }} invite {{ pendingResponses === 1 ? 'request' : 'requests' }} waiting on your hosted events.
      </p>
      <button type="button" class="feed-widget-link" @click="goToHosting">Review hosting</button>
    </div>

    <div class="feed-widget-card">
      <div class="feed-widget-card__title">Hosting tips</div>
      <p class="feed-widget-card__body">
        Add a cover photo, set a clear capacity, and share early so members can mark themselves interested.
      </p>
    </div>

    <div class="feed-widget-card feed-widget-card--muted">
      <div class="feed-widget-card__title">Explore more</div>
      <div class="feed-widget-card__links">
        <button type="button" class="feed-widget-link" @click="goTo('Feed')">Back to feed</button>
        <button type="button" class="feed-widget-link" @click="goTo('Search')">Find members</button>
        <button type="button" class="feed-widget-link" @click="goTo('Flirt')">Open chat</button>
      </div>
    </div>
  </aside>
</template>

<script setup lang="ts">
import {useIonRouter} from '@ionic/vue';

defineProps({
  pendingResponses: {
    type: Number,
    default: 0,
  },
});

const emit = defineEmits<{
  (e: 'select-tab', value: string): void
}>();

const ionRouter = useIonRouter();

const goTo = (name: string) => {
  ionRouter.navigate({name}, 'forward', 'push');
};

const goToHosting = () => {
  emit('select-tab', 'my-events');
};
</script>
